/**
 * @file Clear "X" icon used by clearable terminal/buffer headers.
 * @module @labcraft/ui/icons/clear-x
 *
 * Inline SVG inheriting `currentColor`. Consumers control size via
 * `width`/`height` props or CSS, color via `color` on a parent.
 */

import type { JSX, SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement>

/**
 * Clear/dismiss "X" icon.
 *
 * @param props - Pass-through props for the underlying `<svg>`.
 * @returns The rendered icon.
 */
export function ClearXIcon(props: IconProps): JSX.Element {
  return (
    <svg
      viewBox="0 0 12 12"
      width={12}
      height={12}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}>
      <line x1={3} y1={3} x2={9} y2={9} />
      <line x1={9} y1={3} x2={3} y2={9} />
    </svg>
  )
}
